import { useState, useEffect, useRef } from 'react';
import { onToast } from '../lib/toast';

export default function ToastDisplay() {
  const [toast, setToast] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    // showToast ignores the listener's return value, so the dismiss timer must
    // be tracked here — a stale timer from an earlier toast would otherwise
    // hide a newer toast early.
    const off = onToast((message, duration) => {
      clearTimeout(timerRef.current);
      setToast(message);
      timerRef.current = setTimeout(() => setToast(null), duration);
    });
    return () => {
      off();
      clearTimeout(timerRef.current);
    };
  }, []);

  if (!toast) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 80,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 9998,
      background: '#1a2235',
      color: '#e8e0d8',
      fontSize: 13,
      fontWeight: 500,
      padding: '10px 18px',
      borderRadius: 8,
      border: '1px solid rgba(212,168,74,0.35)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
      pointerEvents: 'none',
      maxWidth: 'calc(100vw - 32px)',
      whiteSpace: 'normal',
      textAlign: 'center',
    }}>
      {toast}
    </div>
  );
}
